// extracted by mini-css-extract-plugin
export var progressContainer = "_gx-0";